import React from "react";

const Courses = () => {
  const courses = [
    { title: "Full Stack Web Development", price: "$199" },
    { title: "Graphic Design Masterclass", price: "$149" },
    { title: "Digital Marketing Expert", price: "$179" },
  ];

  return (
    <div className="container py-5">
      <h2 className="text-primary mb-4 text-center">Our Courses</h2>
      <div className="row g-4">
        {courses.map((c, i) => (
          <div className="col-lg-4 col-md-6" key={i}>
            <div className="course-item border rounded overflow-hidden p-4 text-center">
              <h5>{c.title}</h5>
              <p className="text-primary fw-bold">{c.price}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Courses;
